import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import Imgix from 'lib/tags/imgix'
import I18n from 'lib/i18n'

import friendsLogic from './logic'

const Friends = ({ facebookFriends, id }) => {
  const logic = friendsLogic({ id })

  const { localFriends, localCount, isLoading, dpr } = useValues(logic)
  const { loadMore } = useActions(logic)

  const { friends, count } = facebookFriends

  if (count === 0) {
    return null
  }

  const friendsToShow = localFriends || friends || []
  const friendCount = localCount || count

  const loadMoreFriends = event => {
    event.preventDefault()
    loadMore()
  }

  let friendIndex = 0

  return (
    <div className='widget nospace friends'>
      <h3 className='boxtitle line'>
        {I18n.t('profiles.show.nr_friends_on_apprentus', { count: friendCount })}

        {count > 6 && friendsToShow.length <= 6 ? (
          <a href='#' onClick={loadMoreFriends} style={isLoading ? { cursor: 'wait' } : {}}>
            &nbsp;
            <small>({I18n.t('profiles.show.view_all')})</small>
          </a>
        ) : null}
      </h3>
      <div className='friends-to-show'>
        {friendsToShow.map(user => (
          <a
            key={user.id}
            className='facebook-friend slimmer'
            href={user.url}
            style={friendIndex++ % 3 === 2 ? { marginRight: 0 } : {}}
          >
            <Imgix src={user.avatar} width={87} alt={user.avatar_alt} itemProp='image' dpr={dpr} />
            <div className='friend-name'>{user.name}</div>
          </a>
        ))}
      </div>
    </div>
  )
}

Friends.propTypes = {
  id: PropTypes.number,
  facebookFriends: PropTypes.shape({
    friends: PropTypes.array,
    count: PropTypes.number
  })
}

export default Friends
